import { classModule, propsModule, attributesModule, styleModule, datasetModule } from 'snabbdom';
var modules = [
    styleModule,
    classModule,
    propsModule,
    attributesModule,
    datasetModule,
];
export { styleModule, classModule, propsModule, attributesModule, datasetModule };
export default modules;
//# sourceMappingURL=modules.js.map